"use client";

import { useEffect, useRef, useState } from 'react';
import styles from './_hcp-dr-quote.module.scss';
import CustomImage from '@/components/image';

export default function HcpDrQuote({
  children,
  doctor = null,
  theme = 'pink', // 'pink' | 'tan' | 'lilac'
  borderClassName = '',
  bottomTextColor = '',
  className = '',
}) {
  const containerRef = useRef(null);
  const { name, specialty, image, note } = doctor ?? {};
  const [playState, _setPlayState] = useState(false);
  const playStateRef = useRef(playState);
  function setPlayState(val) {
    _setPlayState(val);
    playStateRef.current = val;
  }
  const [scrollTrigger, _setScrollTrigger] = useState(null);
  const scrollTriggerRef = useRef(scrollTrigger);
  function setScrollTrigger(val) {
    _setScrollTrigger(val);
    scrollTriggerRef.current = val;
  }

  useEffect(() => {
    let ctx = null;

    (async () => {
      const gsap = (await import('gsap')).default;
      const { ScrollTrigger } = await import('gsap/ScrollTrigger');

      gsap.registerPlugin(ScrollTrigger);

      function updateValues() {
        if (containerRef.current !== null) {
          !playStateRef.current && setPlayState(ScrollTrigger.isInViewport(containerRef.current, 0.33));
          // playStateRef.current && setPlayState(ScrollTrigger.positionInViewport(containerRef.current, "center") > 0 && ScrollTrigger.positionInViewport(containerRef.current, "center") <= 1 );
        }
      }
      
      function init() {
        const name = 'quote-ani' + Math.floor(Math.random() * 10000);
        ScrollTrigger.getById(name)?.kill();
        setScrollTrigger(ScrollTrigger.create({
          id: name,
          start: 0,
          end: "max",
          onUpdate: updateValues
        }));
      }

      ctx = gsap.context(() => {
        init();
      });

      return () => {
        if (ctx) ctx.revert();
      };
    })();
  }, []);

  useEffect(() => {
    // console.log('Play state changed:', playState);
    if (playState) {
      // Play the animation
    } else {
      // Pause the animation
    }
  }, [playState]);

  return (
    <section className={`hcp-dr-quote ${styles.quote} ${styles[theme]} ${playState? styles.animate : ''} ${!doctor ? styles.no_doctor : ''} ${className}`.trim()} ref={containerRef}>
      {['pink', 'tan'].includes(theme) && (
        <CustomImage
        src={theme === 'pink' ? '/images/components/bg-crumble-purple.jpg' : '/images/components/bg-crumble-tan.jpg'}
        width={2880}
        height={1300}
        className={styles.quote_bg}
        loading="eager"
        fetchPriority="high"
      />)}
        <div className={`container container--px-16 ${styles.quote_container}`}>
          <div className={`hcp-dr-quote__border ${styles.quote_border} ${borderClassName}`} aria-hidden="true">
            <div className={`hcp-dr-quote__border-left ${styles.quote_border_left} ${playState? styles.animate : ''}`}>
              <svg viewBox="0 0 464 368" fill="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" preserveAspectRatio='none' transform='scale(1, -1)' focusable="false">
                <path d="M463.875 367H16C7.71573 367 1 360.284 1 352V16C1 7.71573 7.71573 1 16 1H463.875" stroke="#F06622" strokeWidth="2" strokeDasharray="1" strokeDashoffset="0" pathLength="1" strokeLinejoin="round" />
              </svg>
              <svg style={{ display: 'none' }} width="100%" height="100%" viewBox="0 0 171 368" preserveAspectRatio='none' fill="none" transform='scale(1, -1)' className={styles.quote_svg_mobile} focusable="false">
                <path d="M171 367H16C7.71573 367 1 360.284 1 352V16C1 7.71573 7.71573 1 16 1H171" stroke="#F06622" strokeWidth="2" strokeDasharray="1" strokeDashoffset="0" pathLength="1" strokeLinejoin="round" />
              </svg>
            </div>
            <div className={`hcp-dr-quote__border-right ${styles.quote_border_right} ${playState? styles.animate : ''}`}>
              <svg viewBox="0 0 464 368" fill="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" preserveAspectRatio='none' transform='scale(-1, -1)' focusable="false">
                <path d="M463.875 367H16C7.71573 367 1 360.284 1 352V16C1 7.71573 7.71573 1 16 1H463.875" stroke="#F06622" strokeWidth="2" strokeDasharray="1" strokeDashoffset="0" pathLength="1" strokeLinejoin="round" />
              </svg>
              <svg style={{ display: 'none' }} width="100%" height="100%" viewBox="0 0 171 368" preserveAspectRatio='none' fill="none" transform='scale(-1, -1)' className={styles.quote_svg_mobile} focusable="false">
                <path d="M171 367H16C7.71573 367 1 360.284 1 352V16C1 7.71573 7.71573 1 16 1H171" stroke="#F06622" strokeWidth="2" strokeDasharray="1" strokeDashoffset="0" pathLength="1" strokeLinejoin="round"/>
              </svg>
            </div>

          </div>
          <CustomImage
            src='/images/icons/icon-quote-mark.png'
            width={53}
            height={60}
            className={styles.quote_icon}
            loading="eager"
            fetchPriority="high"
          />
          <p className={`hcp-dr-quote__text ${styles.quote_text} ${styles.quote_text_visible}`}>
            {children}
          </p>
          <p className={`hcp-dr-quote__text ${styles.quote_text} ${styles.quote_text_hidden}`}>
            {children}
          </p>
          {doctor && (
          <div className={`hcp-dr-quote__author ${styles.quote_author}`}>
            <CustomImage
              src={image}
              width={150}
              height={150}
              className={`hcp-dr-quote__author-img ${styles.quote_author_img}`}
            />
            <span className={`hcp-dr-quote__author-name ${styles.quote_author_name}`}>{name}</span>
            <span className={`hcp-dr-quote__author-position ${styles.quote_author_position} ${bottomTextColor}`}>{specialty}</span>
            {note && <span className={`hcp-dr-quote__author-note ${styles.quote_author_note} ${bottomTextColor}`}>{note}</span>}
          </div>
          )}
        </div>
    </section>
  );
}